<template>
  <info>
    <div v-html="
        $t('RESELLER_PROGRAM_DESC_9', {
          staffSignUpLink: 'https://a.appdb.to/acp.php?action=signup',
          paymentForRef: pay_for_ref,
          paymentPlusForRef: plus_pay_for_ref,
          paidToRefs,
          paidToStaff: paid_staff_funds,

          appRequestsLink: '/requests',
          spentOnRequests: requests_paid_funds,
        })
      "
    ></div>
    <br/><br/><br/><br/>

    <div
      v-html="
        $t('RESELLER_PROGRAM_DESC_1', {
          paidToResellers,
          privacyIconLink: 'https://oldstatic.appdb.to/img/privacy-icon@2x.png',
        })
      "
    ></div>
    <div
      v-html="
        $t('RESELLER_PROGRAM_DESC_2', {
          pricePerDevice: price_per_device,
        })
      "
    ></div>
    <div v-html="$t('RESELLER_PROGRAM_DESC_3')"></div>
    <div v-html="$t('RESELLER_PROGRAM_DESC_4')"></div>
    <div v-html="$t('CREATE_STAFF_ACCOUNT_TO_CONTINUE', {
            staffSignUpLink: 'https://a.appdb.to/acp.php?action=signup'})"></div>

    <template slot="sidebar">
      <html-with-links
        :html="
          $t('RESELLER_PROGRAM_SIDEBAR', {
            staffSignUpLink: 'https://a.appdb.to/acp.php?action=signup',
            refProgramLink: '#ref_program',
            devAccountProgramLink: '#dev_account_program',
            staffSupportLink: '#staff_support',
            requestsFundLink: '#requests_fund',
          })
        "
      ></html-with-links>
    </template>
  </info>
</template>

<script>
import Info from '@/components/Info';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';

export default {
  components: { Info, HtmlWithLinks },
  data() {
    return {
      paidToResellers: null,
      paidToRefs: null,
      pay_for_ref: null,
      plus_pay_for_ref: null,
      paid_staff_funds: null,
      requests_paid_funds: null,
      price_per_device: null,
    };
  },
  computed: {
    title() {
      return `${this.BRAND_CONFIG.name}'s developer account reseller program`;
    },
  },
  methods: {
    getStats() {
      return this.$api.getStats().then((response) => {
        this.paidToResellers = response.dev_program_paid;
        this.paidToRefs = response.ref_program_paid_funds;
        this.pay_for_ref = response.pay_for_ref;
        this.plus_pay_for_ref = response.plus_pay_for_ref;
        this.paid_staff_funds = response.paid_staff_funds;
        this.requests_paid_funds = response.requests_paid_funds;
        this.price_per_device = response.price_per_device;
      });
    },
  },
  serverPrefetch() {
    return this.getStats();
  },
  created() {
    this.getStats();
  },
};
</script>
